
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 1.5h9.862M3 14.5h9.862","stroke":"#593289","stroke-width":"1.3","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M11.966 1.5v2.275a1 1 0 01-.293.708L9.276 6.879v1.793l2.397 2.397a1 1 0 01.293.707v2.276M3.898 1.5v2.275a1 1 0 00.293.708l2.396 2.396v1.793L4.191 11.07a1 1 0 00-.293.707v2.276","stroke":"#593289","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"8.827","y":"2.845","width":"1.345","height":"1.793","rx":".672","fill":"#593289"}})])
          )
        }
      }
    